module.exports = __webpack_public_path__ + "img/cd2c8854880d305f70225122e471bc1e.png";